import { SharedModule } from 'src/app/shared/shared.module'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import { MemberModule } from '../../member/member.module'
import { CompetitionBlacklistModule } from '../competition-blacklist/competition-blacklist.module'
import { CompetitionWhitelistModule } from '../competition-whitelist/competition-whitelist.module'
import { CompetitionAddMemberCardComponent } from './add-member-card/show.component'
import { CompetitionTeamAddMemberModalComponent } from './add-member-modal/show.component'
import { CompetitionTeamRoutingModule } from './competition-team-routing.module'
import { CompetitionTeamEffects } from './competition-team.effects'
import * as fromCompetitionTeam from './competition-team.reducer'
import { CompetitionTeamSerializer } from './competition-team.serializer'
import { CompetitionTeamService } from './competition-team.service'
import { CompetitionTeamCreateFormComponent } from './create-form/show.component'
import { CompetitionTeamCreationConfirmationCardComponent } from './create-team-confirmation-card/show.component'
import { CompetitionTeamCreationConfirmationModalComponent } from './create-team-confirmation-modal/show.component'
import { CompetitionTeamCreateComponent } from './create/show.component'
import { CompetitionTeamMatchesTabComponent } from './matches-tab/show.component'
import { CompetitionTeamMembersTabComponent } from './members-tab/show.component'
import { CompetitionTeamOverviewComponent } from './overview/show.component'
import { CompetitionTeamPlanningTabComponent } from './planning-tab/show.component'
import { CompetitionTeamRefereeTabComponent } from './referee-tab/show.component'
import { CompetitionTeamResultsTabComponent } from './results-tab/show.component'
import { CompetitionTeamTablesTabComponent } from './tables-tab/show.component'
import { CompetitionTeamTopScorerComponent } from './top-scorer-tab/show.component'
import { CompetitionMatchModule } from '../competition-match/competition-match.module'
import { CompetitionPoolModule } from '../competition-pool/competition-pool.module'

@NgModule({
  imports: [
    CommonModule,
    CompetitionTeamRoutingModule,
    SharedModule,
    StoreModule.forFeature(
      fromCompetitionTeam.FEATURE_NAME,
      fromCompetitionTeam.competitionTeamReducer
    ),
    EffectsModule.forFeature([CompetitionTeamEffects]),
    MemberModule,
    CompetitionBlacklistModule,
    CompetitionWhitelistModule,
    CompetitionMatchModule,
    CompetitionPoolModule
  ],
  providers: [
    CompetitionTeamService,
    {
      provide: CompetitionTeamSerializer,
      useClass: CompetitionTeamSerializer
    }
  ],
  declarations: [
    CompetitionTeamOverviewComponent,
    CompetitionTeamCreateComponent,
    CompetitionTeamMatchesTabComponent,
    CompetitionTeamResultsTabComponent,
    CompetitionTeamTablesTabComponent,
    CompetitionTeamTopScorerComponent,
    CompetitionTeamCreateFormComponent,
    CompetitionTeamPlanningTabComponent,
    CompetitionTeamAddMemberModalComponent,
    CompetitionTeamCreationConfirmationModalComponent,
    CompetitionTeamCreationConfirmationCardComponent,
    CompetitionTeamMembersTabComponent,
    CompetitionAddMemberCardComponent,
    CompetitionTeamRefereeTabComponent
  ],
  exports: [
    CompetitionTeamOverviewComponent,
    CompetitionTeamMatchesTabComponent,
    CompetitionTeamResultsTabComponent,
    CompetitionTeamTablesTabComponent
  ]
})
export class CompetitionTeamModule {}
